import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { TbX } from "react-icons/tb";

export const VoucherModal = ({ open, onClose, title, children }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle className="flex items-center justify-between gap-3 !pb-2">
      <span className="text-base font-bold text-brand-dark">{title}</span>
      <IconButton size="small" onClick={onClose} aria-label="Fechar">
        <TbX className="h-4 w-4" />
      </IconButton>
    </DialogTitle>
    <DialogContent className="!pt-2">{children}</DialogContent>
  </Dialog>
);
